<script setup>

import axios from "@/axios";
import {onBeforeMount, onMounted, onUpdated, ref, watch} from "vue";
import {useComStore, useLanguageStore} from "@/pinia";

const props = defineProps(['readonly', 'meetingRoom', 'isReset', 'label']);
const emits = defineEmits(['set_meetingRoom']);
const isReadOnly = ref(false);
const selectedMeetingRoom = ref();
const items = ref();
const useComCode = useComStore();
const languageStore = useLanguageStore();

const changeMeetingRoom =(cr)=>{
  console.log(selectedMeetingRoom.value);
  emits('set_meetingRoom', cr);
}

onMounted(()=>{
  items.value = useComCode.getCodeType('meetingLocation');
})
onUpdated(()=>{
  isReadOnly.value = props.readonly ?? false;
})
onBeforeMount(()=>{
  selectedMeetingRoom.value = props.meetingRoom != null  ?props.meetingRoom.codeId : null;
})

watch(()=>props.isReset , ()=>{
  console.log("meetingRoom IsReset : " + props.isReset)
  if(props.isReset){
    selectedMeetingRoom.value= null ;
  }
})

</script>

<template>
  <v-select
      v-model="selectedMeetingRoom"
      @update:modelValue="changeMeetingRoom"
      :items="items"
      item-value="codeId"
      item-title="codeNm"
      :readonly="isReadOnly"
      :label="label"
      :placeholder="!label ? languageStore.get('select') : undefined"
      variant="outlined"
      density="compact"
      hide-details="auto"
      clearable
  />
</template>

<style scoped>

</style>